import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { CompanyProvider } from '../../../contexts/companyContext';
import { useAuth } from '../../../hooks/useAuth';
import Footer from '../../Shared/Footer';
import AppBar from '../../Shared/appbar/appbar';


export function OpenRoute() {
    return (
        <CompanyProvider>
            <AppBar />
            <div className=''>
                <Outlet />
            </div>
            <Footer />
        </CompanyProvider>

    )
        
}